import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import UserService from '../services/UserService';
import PermissionService from '../services/PermissionService';

const initialState = {
  data: [],
  datas: [],
  missingPermissions: [],
  formError: [],
  error: null,
  status: '',
  dataLoading: false,
  submitLoading: false,

  isOpenPermissionDialog: false,
};

export const fetchPermissionList = createAsyncThunk(
  'permission/fetchPermissionList',
  async (data) => {
    try {
      const resp = await PermissionService.PermissionList(data);
      return resp;
    } catch (error) {
      return error.response.data;
    }
  },
);

export const createPermission = createAsyncThunk('permission/createPermission', async (data) => {
    const response = await PermissionService.CreatePermission(data);
    return response;
});

export const deletePermission = createAsyncThunk('permission/deletePermission', async (data) => {
  const response = await PermissionService.DeletePermission(data);
  return response;
});

const permissionSlice = createSlice({
  name: 'permission',
  initialState: initialState,
  reducers: {
    openPermissionDialog: (state, action) => {
      state.isOpenPermissionDialog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissionList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchPermissionList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data.data?.existing_permissions];
          state.missingPermissions = [...action.payload?.data.data?.missing_permissions];
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchPermissionList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(createPermission.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(createPermission.fulfilled, (state, action) => {
        state.datas = [...action.payload?.data.data?.existing_permissions];
        state.missingPermissions = [...action.payload?.data.data?.missing_permissions];
        state.submitLoading = false;
        toast.success(action.payload?.data.message);
      })
      .addCase(createPermission.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
        toast.error('Failed to delete permission');
      })
      .addCase(deletePermission.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(deletePermission.fulfilled, (state, action) => {
        state.status = '';
        state.datas = [...action.payload?.data.data?.existing_permissions];
        state.missingPermissions = [...action.payload?.data.data?.missing_permissions];
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
        state.isOpenPermissionDialog = false;
        toast.success(action.payload?.data.message);
      })
      .addCase(deletePermission.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
        toast.error('Failed to delete permission');
      });
  },
});

const { reducer } = permissionSlice;

export const { openPermissionDialog } = permissionSlice.actions;

export const permissionSelector = (state) => state?.permission;

export default reducer;
